import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Divider, Grid, Typography } from '@material-ui/core';
import { isEmpty, uniqueId } from 'lodash';
import WarningIcon from '../../../../MUI/Icons/WarningIcon';
import SuccessIcon from '../../../../MUI/Icons/SuccessIcon';
import AmountCompensation from '../../AmountCompensation';
import Currency from '../../../../Currency';
import useDeviceResize from '../../../../../hooks/useDeviceResize';
import { getProgramColorByType } from '../../../../../helpers/travel/travelCalcHelpers';
import Tabs from './Tabs';

import useStyles from '../makeStyles';

const ProgramSelection = ({
  plans,
  type,
  selectedPlan,
  handleChangePlan,
  setSelectedLimit,
  availableLimits,
  selectedLimit,
  isFetchingPrice,
  amount,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [currentPlan, setCurrentPlan] = useState({});
  const isDeviceMdSize = useDeviceResize('md');

  useEffect(() => {
    if (!isEmpty(plans) && !!plans.length) {
      setCurrentPlan(plans.find((item) => item.label === selectedPlan));
    }
  }, [plans, selectedPlan]);

  return (
    <Grid container>
      <Grid item xs={12} xl={12} className={classes.tabsContainer}>
        <Tabs
          plans={plans}
          handleChangePlan={handleChangePlan}
          selectedPlan={selectedPlan}
          type={type}
        />
      </Grid>
      <Grid
        item
        xs={12}
        className={classes.divider}
        style={{
          backgroundColor: `${getProgramColorByType(selectedPlan)}`,
        }}
      />
      <Grid container item xs={12} xl={12} className={classes.programDetails}>
        <Grid item xs={12} md={5} style={{ paddingRight: !isDeviceMdSize ? '2rem' : '0' }}>
          <Grid
            container
            style={{
              backgroundColor: `${getProgramColorByType(selectedPlan)}`,
            }}
            className={classes.priceSection}
            alignItems="center"
            justifyContent="center"
            alignContent="center"
            direction="row-reverse"
          >
            <Grid
              item
              className={classes.amountWrapper}
              style={{
                paddingRight: isDeviceMdSize ? 10 : 0,
                textAlign: isDeviceMdSize ? 'right' : 'center',
              }}
              md={12}
              xs={6}
            >
              <Currency value={amount} isFetching={isFetchingPrice} placeholder="-" withSymbol />
            </Grid>
            <Grid className={classes.textWrapper} item md={12} xs={6}>
              <span
                style={{
                  paddingLeft: isDeviceMdSize ? 10 : 0,
                  textAlign: isDeviceMdSize ? 'justify' : 'center',
                }}
                className={classes.text}
              >
                {t('insurance.price')}
              </span>
            </Grid>
          </Grid>
          <AmountCompensation
            setSelectedLimit={setSelectedLimit}
            availableLimits={availableLimits}
            selectedLimit={selectedLimit}
          />
        </Grid>
        <Grid item xs={12} md={7} className={classes.plansDescription}>
          {!isEmpty(currentPlan)
            && !isEmpty(currentPlan.descriptions)
            && currentPlan.descriptions.map((n) => (
              <Grid className={classes.infoGrid} container direction="row" key={uniqueId()}>
                <Grid item className={classes.icon}>
                  <SuccessIcon />
                </Grid>
                <Grid item xs={10}>
                  <Typography className={classes.label}>
                    {t(`travel.types.${currentPlan.label}.description${n}`)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
        </Grid>
        <Grid item xs={12}>
          {!isEmpty(currentPlan) && !!currentPlan.warnings.length && (
            <Divider style={{ marginBottom: '1rem' }} />
          )}
          {!isEmpty(currentPlan)
            && currentPlan.warnings.map((n) => (
              <Grid
                className={classes.infoGrid}
                container
                direction="row"
                key={`${currentPlan.label}-warn-${n}`}
              >
                <Grid item className={classes.icon}>
                  <WarningIcon />
                </Grid>
                <Grid item xs={10}>
                  <Typography className={classes.label}>
                    {t(`travel.types.${currentPlan.label}.warning${n}`)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

ProgramSelection.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      limits: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
          currency: PropTypes.string.isRequired,
        }),
      ).isRequired,
      descriptions: PropTypes.arrayOf(PropTypes.number).isRequired,
      warnings: PropTypes.arrayOf(PropTypes.number).isRequired,
      headColor: PropTypes.string.isRequired,
      coverages: PropTypes.shape({}).isRequired,
    }),
  ).isRequired,
  selectedPlan: PropTypes.string.isRequired,
  handleChangePlan: PropTypes.func.isRequired,
  availableLimits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      currency: PropTypes.string,
      value: PropTypes.number,
    }),
  ).isRequired,
  selectedLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  setSelectedLimit: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isFetchingPrice: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
};
export default memo(ProgramSelection);
